const API_CONFIG = {
    baseURL:
        process.env.NODE_ENV === 'production'
            ? "https://sistemaintegrado.palmont.com.br"
            : "http://localhost"
}

export default API_CONFIG;